import { computed, reactive } from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAnglesRight,
  faAnglesLeft,
  faArrowLeft,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faArrowRight);
library.add(faArrowLeft);
library.add(faAnglesRight);
library.add(faAnglesLeft);

export default {
  name: 'PaginationComponent',
  components: {
    FontAwesomeIcon,
  },
  props: {
    pagination: {
      type: Object,
      required: true,
      default: {},
    },
    maxShow: {
      type: Number,
      required: false,
      default: 3,
    },
  },
  emits: ['change'],
  inject: [],
  setup(props) {
    const state = reactive({
      pagination: reactive(props.pagination),
      maxShow: props.maxShow,
      currentPage: computed(() => {
        return props.pagination.page;
      }),
      totalPages: computed(() => {
        return props.pagination.total_pages
          ? props.pagination.total_pages
          : props.pagination.totalPages;
      }),
      pages: computed(() => {
        const total = Number(state.totalPages);
        const maxShow = state.maxShow;
        let array = [];
        if (total <= maxShow) {
          for (let i = 1; i <= total; i++) {
            array.push(i);
          }
        } else {
          const current = Number(state.currentPage);
          const delta = maxShow % 2 === 0
            ? Math.floor((maxShow - 1) / 2)
            : Math.floor(maxShow / 2);
          let left = current - delta;
          let right = current + delta;
          if (current <= delta) {
            right = maxShow;
          }
          if (current >= total - delta) {
            left = total + 1 - maxShow;
          }
          for (let i = 1; i <= total; i++) {
            if (i >= left && i <= right) {
              array.push(i);
            }
          }
        }

        return array;
      }),
      showingFirst: computed(() => {
        return state.currentPage === 1;
      }),
      showingLast: computed(() => {
        return state.currentPage === state.totalPages;
      }),
    });

    return {
      state,
    };
  },
  methods: {
    firstPage() {
      this.$emit('change', 1);
    },
    prevPage() {
      if (this.state.currentPage > 1) {
        const page = this.state.currentPage - 1;
        this.$emit('change', page);
      }
    },
    nextPage() {
      if (this.state.currentPage < this.state.totalPages) {
        const page = this.state.currentPage + 1;
        this.$emit('change', page);
      }
    },
    lastPage() {
      this.$emit('change', this.state.totalPages);
    },
    setPage(page) {
      this.$emit('change', page);
    },
    isCurrentPage(page) {
      return page === this.state.currentPage;
    },
  },
};
